import { upperCase } from "lodash";
import removeKey from "LIB/removeKey";
import { properCase } from "LIB/formatters/text";
import { IMPERFECT_TRACE_REASON } from "MODULES/companies/constants";
import { INCIDENT } from "MODULES/PurchaseOrders/constants";
import { SERVICEABLE_TOOLING } from "MODULES/IncomingQuotes/constants";
import { PHOTOS_RECEIVING_PACKAGING_INSPECTION } from "MODULES/Receiving/constants";

export const INVENTORY = "inventory";

export const AS_IS = "as_is";
export const AIRCRAFT_REFERENCE_NUMBER = "aircraft_reference_number";
export const AIRCRAFT_TAIL_NUMBER = "aircraft_tail_number";
export const CONDITION = "condition";
export const CONSIGNED_DATE = "consigned_date";
export const CONSIGNMENT_TYPE = "consignment_type";
export const COST_PER_UNIT = "cost_per_unit";
export const CORE_RETURN_SERIAL_NUMBER = "core_return_serial_number";
export const DO_NOT_EXCHANGE = "do_not_exchange";
export const DO_NOT_SELL_REASON = "do_not_sell_reason";
export const EXCHANGE_SRP = "exchange_srp";
export const FLAT_EXCHANGE_SRP = "flat_exchange_srp";
export const EXCHANGE_SERIAL_NUMBER = "exchange_serial_number";
export const EXPIRATION = "expiration";
export const FREIGHT_COMPLETE = "freight_complete";
export const FINAL_FREIGHT_CONFIRMED = "final_freight_confirmed";
export const INTERNAL_OUTRIGHT_SALES_ITEM_ID =
  "internal_outright_sales_item_id";
export const MOST_RECENT_SALES_ORDER = "most_recent_sales_order";
export const LOCATION = "location";
export const LAST_SRP_REASON_CHANGED = "last_srp_reason_changed";
export const LEAD_TIME = "lead_time";
export const LEAD_TIME_LABEL = "Lead Time (Days)";
export const LISTING_OVERRIDE = "listing_override";
export const MANAGED_REPAIR_IN_PROGRESS = "managed_repair_in_progress";
export const MANAGED_REPAIR_REPAIRED = "managed_repair_repaired";
export const ORIGINAL_COST_PER_UNIT = "original_cost_per_unit";
export const PART_ID = "part_id";
export const REPAIR_STATUS = "repair_status";
export const SERIAL_NUMBER = "serial_number";
export const SRP_CONDITION = "srp_condition";
export const SRP_REASON_CHANGED = "srp_reason_changed";
export const SRP_REASON_CHANGED_LABEL = "SRP Reason Changed";
export const SELLABLE_STATUS = "sellable_status";
export const STORE_OWNER = "store_owner";
export const STORE_OWNER_ID = "store_owner_id";
export const STORE_LOCATION = "store_location";
export const STORE_LOCATION_ID = "store_location_id";
export const SUGGESTED_RETAIL = "suggested_retail";
export const TAG_DATE = "tag_date";
export const TAGGED_BY = "tagged_by";
export const TAGGED_BY_ID = "tagged_by_id";
export const TAGGED_BY_HOLD = "tagged_by_hold";
export const TRACED_TO = "traced_to";
export const TOTAL_HOURS_REMAINING = "total_hours_remaining";
export const TOTAL_CYCLES_REMAINING = "total_cycles_remaining";
export const TRACE_TYPE = "trace_type";
export const TRANSFER_TO_LOCATION_ID = "transfer_to_location_id";
export const UNSELLABLE_PER_USER = "unsellable_per_user";
export const WARRANTY = "warranty";
export const WARRANTY_OVERRIDE = "warranty_override";
export const WAREHOUSE = "warehouse";

export const OVERHAULED = "overhauled";
export const REPAIRED = "repaired";
export const INSPECTED = "inspected";
export const NEW_ITEM = "new_item";
export const AS_REMOVED = "as_removed";
export const BEYOND_REPAIR = "beyond_econ_repair";
export const PARTS_UNIT = "parts_unit";
export const SCRAP = "scrap";
export const UNDO_SCRAP = "scrap";

export const IN_STOCK = "in_stock";
export const CORE_RETURNED_TO_CUSTOMER = "core_returned_to_customer";
export const CUSTOMER_RMA_REQUESTED = "customer_rma_requested";
export const DISCREPANCY_REPORTED = "discrepancy_reported";
export const AWAITING_SCRAP_REPORT_AT_SHOP = "awaiting_scrap_report_at_shop";
export const AWAITING_SCRAP_REPORT_LOCAL = "awaiting_scrap_report_local";
export const AT_SHOP = "at_shop";
export const CORE_RETURN_RECEIVED = "core_return_received";
export const CORE_RETURN_REJECTED = "core_return_rejected";
export const EXCHANGE_GONE_OUTRIGHT = "exchange_gone_outright";
export const GONE = "gone";
export const ON_ORDER_FOR_SALE = "on_order_for_sale";
export const OUT_ON_EXCHANGE = "out_on_exchange";
export const TRANSFER_USA_BOUND = "transfer_usa_bound";
export const TRANSFER_IRE_BOUND = "transfer_ireland_bound";
export const TRANSFER_SGP_BOUND = "transfer_singapore_bound";
export const INTERNAL_OUTRIGHT = "internal_outright";
export const QC_STATUS = "qc_status";
export const RECLAIMED = "reclaimed";
export const NO_WORK_PERFORMED = "no_work_performed";
export const REPAIR_EVALUATION_REJECTED = "repair_evaluation_rejected";
export const REPAIR_EVALUATION_RECEIVED = "repair_evaluation_received";
export const RETURNING_FROM_SHOP = "returning_from_shop";
export const REPAIRING = "repairing";
export const RESERVE_FOR_SALE = "reserve_for_sale";
export const RETURNING_TO_CUSTOMER = "returning_to_customer";
export const RMA_RECEIVED = "rma_received";
export const SALES_ORDER_CREATED = "sales_order_created";
export const SCRAP_REPORT = "scrap_report";
export const RESERVE_FOR_REPAIR = "reserve_for_repair";
export const REPAIR_AND_HOLD = "repair_and_hold";
export const REPAIR_AND_HOLD_LEAD_TIME = "repair_and_hold_lead_time";
export const REPAIR_EVALUATION_APPROVED = "repair_evaluation_approved";
export const RETURNING_ASSIGNED_CORE = "returning_assigned_core";
export const RETURNED_CONSIGNMENT = "returned_consignment";
export const RETURNING_CONSIGNMENT = "returning_consignment";
export const RESERVE_FOR_SHOP_ASSIST = "reserve_for_shop_assist";
export const STATUS = "status";
export const WORKING_TO_SAVE_UNIT = "working_to_save_unit";
export const UNIT_RETURNED_TO_CUSTOMER = "unit_returned_to_customer";
export const UNDER_REVIEW = "under_review";
export const QC_HOLD = "qc_hold";
export const PASS = "pass";
export const RETURNING_FROM_SHOP_TO_CUSTOMER =
  "returning_from_shop_to_customer";
export const VENDOR_RMA_REQUESTED = "vendor_rma_requested";
export const VENDOR_RMA_IN_PROGRESS = "vendor_rma_in_progress";

export const DO_NOT_SELL = "do_not_sell";
export const LIST = "list";
export const DO_NOT_LIST = "do_not_list";

export const ASA = "asa";
export const FAA = "faa";
export const EASA = "easa";
export const CAAC = "caac";
export const TCCA = "tcca";
export const UK_CAA = "uk_caa";
export const OTHER_TAG_TYPE = "other_tag_type";
const IMPERFECT_TRACE = "imperfect_trace";
const DER = "der";
const PMA = "pma";
export const MODIFIED = "modified";
export const WARE_HOUSE_ID = "ware_house_id";

export const DO_NOT_SELL_REASON_OPTIONS = [
  { value: "hold_for_airline_customer", text: "Hold for Airline Customer" },
  { value: "special_project", text: "Special Project" },
  { value: "see_buyer_for_more_info", text: "See Buyer for More Info" }
];

export const IMPERFECT_TRACE_REASONS = {
  missing_accompanying_shop_report: {
    label: "Missing accompanying shop report"
  },
  missing_links: {
    label: "Missing link/s"
  },
  missing_nis: {
    label: "Missing NIS"
  },
  missing_removal_tag: {
    label: "Missing removal tag"
  },
  other: {
    label: "Other"
  }
};

export const TAG_TYPES = {
  [ASA]: {
    label: "ASA"
  },
  [FAA]: {
    label: "FAA"
  },
  [EASA]: {
    label: "EASA"
  },
  [CAAC]: {
    label: "CAAC"
  },
  [TCCA]: {
    label: "TCCA"
  },
  [UK_CAA]: {
    label: "UK CAA"
  }
};

export const FLAG_TYPES = {
  [IMPERFECT_TRACE]: {
    label: properCase(IMPERFECT_TRACE),
    subLabel: inventory =>
      inventory[IMPERFECT_TRACE_REASON] &&
      IMPERFECT_TRACE_REASONS[inventory[IMPERFECT_TRACE_REASON]].label
  },
  [DER]: {
    label: "DER"
  },
  [PMA]: {
    label: "PMA"
  },
  [MODIFIED]: {
    label: "Modified"
  },
  [INCIDENT]: {
    label: properCase(INCIDENT)
  }
};

export const STATUSES = {
  [IN_STOCK]: {
    label: "In Stock"
  },
  [AWAITING_SCRAP_REPORT_AT_SHOP]: {
    label: "Awaiting Scrap Report - At Shop"
  },
  [AWAITING_SCRAP_REPORT_LOCAL]: {
    label: "Awaiting Scrap Report - Local"
  },
  [CORE_RETURN_RECEIVED]: {
    label: "Core Return Received"
  },
  [CUSTOMER_RMA_REQUESTED]: {
    label: "Customer RMA Requested"
  },
  [REPAIRING]: {
    label: "Repairing"
  },
  [RESERVE_FOR_SALE]: {
    label: "Reserve For Sale"
  },
  [RETURNING_TO_CUSTOMER]: {
    label: properCase(RETURNING_TO_CUSTOMER)
  },
  [RETURNING_ASSIGNED_CORE]: {
    label: properCase(RETURNING_ASSIGNED_CORE)
  },
  [RETURNING_CONSIGNMENT]: {
    label: properCase(RETURNING_CONSIGNMENT)
  },
  [RMA_RECEIVED]: {
    label: "RMA Received"
  },
  [SALES_ORDER_CREATED]: {
    label: "Sales Order Created"
  },
  [ON_ORDER_FOR_SALE]: {
    label: "On Order For Sale"
  },
  [OUT_ON_EXCHANGE]: {
    label: "Out on Exchange"
  },
  [GONE]: {
    label: "Gone (Out of Stock)"
  },
  [TRANSFER_USA_BOUND]: {
    label: "Transfer USA Bound"
  },
  [TRANSFER_IRE_BOUND]: {
    label: "Transfer Ireland Bound"
  },
  [TRANSFER_SGP_BOUND]: {
    label: "Transfer Singapore Bound"
  },
  [DISCREPANCY_REPORTED]: {
    label: "Discrepancy Reported"
  },
  [OUT_ON_EXCHANGE]: {
    label: "Out On Exchange"
  },
  [VENDOR_RMA_REQUESTED]: {
    label: "Vendor Rma Requested"
  },
  [VENDOR_RMA_IN_PROGRESS]: {
    label: properCase(VENDOR_RMA_IN_PROGRESS)
  }
};

export const REPAIR_STATUSES = {
  [AT_SHOP]: {
    label: "At Shop"
  },
  [INTERNAL_OUTRIGHT]: {
    label: "Internal Outright"
  },
  [EXCHANGE_GONE_OUTRIGHT]: {
    label: "Exchange Gone Outright"
  },
  [REPAIR_EVALUATION_REJECTED]: {
    label: "Repair Evaluation Rejected"
  },
  [WORKING_TO_SAVE_UNIT]: {
    label: "Working To Save Unit"
  },
  [REPAIR_EVALUATION_APPROVED]: {
    label: "Repair Evaluation Approved"
  },
  [REPAIR_AND_HOLD]: {
    label: "Repair And Hold"
  },
  [RESERVE_FOR_REPAIR]: {
    label: "Reserve for Repair"
  },
  [RESERVE_FOR_SHOP_ASSIST]: {
    label: "Reserve For Shop Assist"
  },
  [RETURNING_FROM_SHOP]: {
    label: "Returning From Shop"
  },
  [RETURNING_FROM_SHOP_TO_CUSTOMER]: {
    label: "Returning From Shop To Customer"
  },
  [REPAIRED]: {
    label: "Repaired"
  },
  [CORE_RETURNED_TO_CUSTOMER]: {
    label: "Core Returned To Customer"
  }
};

export const CURRENTLY_REPAIRING_STATUSES = removeKey(
  REPAIR_STATUSES,
  REPAIRED
);

export const CURRENTLY_TRANSFERRING_STATUSES = [
  TRANSFER_IRE_BOUND,
  TRANSFER_SGP_BOUND,
  TRANSFER_USA_BOUND
];

export const QC_STATUSES = {
  [UNDER_REVIEW]: {
    label: "Under Review"
  },
  [QC_HOLD]: {
    label: "QC Hold"
  },
  [PASS]: {
    label: "Pass"
  }
};

export const INVENTORIES = {
  condition: {
    [OVERHAULED]: {
      abbrev: "OH",
      label: "Overhauled"
    },
    [REPAIRED]: {
      abbrev: "SV",
      label: "Repaired"
    },
    [INSPECTED]: {
      abbrev: "BT",
      label: "Inspected"
    },
    [NEW_ITEM]: {
      abbrev: "NE",
      label: "New"
    },
    [AS_REMOVED]: {
      abbrev: "AR",
      label: "As Removed"
    },
    [BEYOND_REPAIR]: {
      abbrev: "BR",
      label: "Beyond Repair"
    },
    [PARTS_UNIT]: {
      abbrev: "PU",
      label: "Parts Unit"
    },
    [SCRAP]: {
      abbrev: "SC",
      label: "Scrap"
    },
    [SERVICEABLE_TOOLING]: {
      abbrev: "SV",
      label: "Serviceable Tooling"
    }
  },
  listing_override: {
    false: {
      label: "Do Not List"
    },
    true: {
      label: "List"
    }
  }
};

export const COST_ADJUSTMENT_OPTIONS = {
  neg_exchange_2nd: {
    label: "2nd Exchange Cost Adjustment (-)",
    cancellable: true,
    abbrev: "2Exch (-)",
    inventory_only: true
  },
  pos_exchange_2nd_reversal: {
    label: "2nd Exchange Reversal Cost Adjustment (+)",
    cancellable: true,
    abbrev: "2ExchRev (+)",
    inventory_only: true
  },
  neg_exchange_3rd: {
    label: "3rd Exchange Cost Adjustment (-)",
    cancellable: true,
    abbrev: "3Exch (-)",
    inventory_only: true
  },
  pos_exchange_3rd_reversal: {
    label: "3rd Exchange Reversal Cost Adjustment (+)",
    cancellable: true,
    abbrev: "3ExchRev (+)",
    inventory_only: true
  },
  pos_assigned_core_return: {
    label: "Assigned Core Return (+)",
    abbrev: "Asgnd Core Return (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_assigned_core_return: {
    label: "Assigned Core Return (-)",
    abbrev: "Asgnd Core Return (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_credit_exchange_sale: {
    label: "Cancelled Outright Sale (Exch Credited) (-)",
    cancellable: true,
    abbrev: "CnclOutRt (ExchCred) (-)",
    inventory_only: true
  },
  pos_cancelled_sales_order: {
    label: "Cancelled Sales Order (+)",
    abbrev: "Cncl SO (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_cancelled_sales_order: {
    label: "Cancelled Sales Order (-)",
    abbrev: "Cncl SO (-)",
    cancellable: true,
    inventory_only: true
  },
  pos_container_fee: {
    label: "Container Fee (+)",
    abbrev: "CntrFee (+)",
    cancellable: true
  },
  neg_core_return_cost_savings: {
    label: "Core Return Cost Savings (-)",
    cancellable: true,
    abbrev: "CoreRt (-)",
    inventory_only: true
  },
  neg_core_return_fee_savings: {
    label: "Core Return Fee Savings (-)",
    abbrev: "Core Return Fee (-)",
    cancellable: true,
    inventory_only: true
  },
  pos_consignor_cost: {
    label: "Consignor's Cost (+)",
    abbrev: "Consignor Cost",
    cancellable: true
  },
  neg_po_credit: {
    label: "Credit Amount (PO) (-)",
    cancellable: true,
    abbrev: "CredAmt PO (-)"
  },
  neg_ro_credit: {
    label: "Credit Amount (RO) (-)",
    abbrev: "CredAmt RO (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_so_credit: {
    label: "Credit Amount (SO) (-)",
    abbrev: "CredAmt SO (-)",
    cancellable: true,
    inventory_only: true
  },
  pos_customer_rma_credit: {
    label: "Customer RMA Credit (+)",
    cancellable: true,
    abbrev: "CustRMA Cred (+)"
  },
  pos_customer_partial_credit: {
    label: "Customer Partial Credit (+)",
    cancellable: true,
    abbrev: "CustPrtl Cred (+)"
  },
  pos_customs_duties_taxes: {
    label: "Customs, Duties & Taxes (+)",
    abbrev: "CustDutTx (+)",
    cancellable: true
  },
  pos_customs_handling_processing_fees: {
    label: "Customs Handling/Processing Fees (+)",
    abbrev: "Cst Hndl/Prcs Fee (+)",
    cancellable: true
  },
  neg_credit_po_exchange_sale: {
    label: "Credit PO Exchange Sale (-)",
    cancellable: true,
    abbrev: "Credit PO Exch",
    inventory_only: true
  },
  pos_credit_exchange_sale: {
    label: "Credited Exchange Sale (+)",
    cancellable: true,
    abbrev: "CnclExchSO (+)",
    inventory_only: true
  },
  neg_depreciation: {
    label: subtype => `Depreciation ${(subtype && `(${subtype}) `) || ""}(-)`,
    cancellable: true,
    abbrev: "Dep (-)"
  },
  pos_evaluation_fee: {
    label: "Evaluation Fee (+)",
    cancellable: true,
    abbrev: "EvFee (+)",
    inventory_only: true
  },
  neg_exchange: {
    label: "Exchange Cost Adjustment (-)",
    cancellable: true,
    abbrev: "Exch (-)",
    inventory_only: true
  },
  neg_exchange_gone_outright: {
    label: "Exchange Gone Outright (SO) (-)",
    cancellable: true,
    abbrev: "ExchGOR SO (-)",
    inventory_only: true
  },
  pos_exchange_reversal: {
    label: "Exchange Reversal (+)",
    cancellable: true,
    abbrev: "ExchRev (+)",
    inventory_only: true
  },
  pos_finders_fee: {
    label: "Finders Fee (+)",
    abbrev: "FndrFee (+)",
    cancellable: true,
    inventory_only: true
  },
  pos_handling_fee: {
    label: "Handling Fee (+)",
    abbrev: "HndlFee (+)",
    cancellable: true
  },
  pos_hazmat_fee: {
    label: "Hazmat Fee (+)",
    abbrev: "Hzmt (+)",
    cancellable: true
  },
  pos_po_incoming_freight: {
    label: "Incoming Freight (PO) (+)",
    abbrev: "IncFrgt PO (+)",
    cancellable: true
  },
  neg_po_incoming_freight: {
    label: "Incoming Freight (PO) (-)",
    abbrev: "Inc Frgt PO (-)",
    cancellable: true
  },
  pos_ro_incoming_freight: {
    label: "Incoming Freight (RO) (+)",
    abbrev: "IncFrgt RO (+)",
    cancellable: true
  },
  neg_ro_incoming_freight: {
    label: "Incoming Freight (RO) (-)",
    abbrev: "Inc Frgt (-)",
    cancellable: true
  },
  pos_rma_incoming_freight: {
    label: "Incoming Freight (RMA) (+)",
    abbrev: "IncFrgt RMA (+)",
    cancellable: true
  },
  neg_internal_outright: {
    label: "Internal Outright (-)",
    cancellable: true,
    abbrev: "IntOut (-)"
  },
  pos_inventory_transfer: {
    label: "Inventory Transfer (+)",
    abbrev: "InvTran (+)",
    cancellable: true
  },
  pos_lot_cost: {
    label: "Lot Cost (+)",
    abbrev: "Lot Cost (+)"
  },
  neg_lot_cost: {
    label: "Lot Cost (-)",
    abbrev: "Lot Cost (-)"
  },
  pos_miscellaneous: {
    label: "Miscellaneous (+)",
    abbrev: "Miscellaneous (+)",
    cancellable: true
  },
  pos_mistake_correction: {
    label: "Mistake Correction (+)",
    abbrev: "MstkCorr (+)",
    cancellable: true
  },
  neg_mistake_correction: {
    label: "Mistake Correction (-)",
    abbrev: "MstkCorr (-)",
    cancellable: true
  },
  pos_rma_outgoing_freight: {
    label: "Outgoing Freight (RMA) (+)",
    cancellable: true,
    abbrev: "OutFrgt RMA (+)"
  },
  pos_ro_outgoing_freight: {
    label: "Outgoing Freight (RO) (+)",
    abbrev: "OutFrgt RO (+)",
    cancellable: true
  },
  pos_po_outright_sale: {
    label: "Outright Purchase (PO) (+)",
    abbrev: "Outright PO (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_partial_credit_request_rma: {
    label: "Partial Credit (PO) (-)",
    cancellable: true,
    abbrev: "Prtl Cred PO (-)"
  },
  neg_partial_credit_from_vendor: {
    label: "Partial Credit From Vendor (-)",
    cancellable: true,
    abbrev: "PrtCred Vendor (-)"
  },
  pos_sale_from_partial_customer_rma: {
    label: "Partially Returned SO (+)",
    cancellable: true,
    abbrev: "Prtl Ret. SO (+)"
  },
  neg_previously_written_down: {
    label: "Previously Written Down (-)",
    cancellable: true,
    abbrev: "PrevWrtDwn (-)"
  },
  neg_pro_bono_writedown: {
    label: "Pro Bono Depreciation (-)",
    abbrev: "ProBono Depr (-)",
    cancellable: true
  },
  pos_repair_assist_fee: {
    label: "Repair Assist Fee (+)",
    cancellable: true,
    abbrev: "RepAsstFee (+)"
  },
  pos_sale_from_customer_rma: {
    label: "Returned SO (+)",
    cancellable: true,
    abbrev: "Returned SO (+)"
  },
  pos_ro_repair: {
    label: subtype =>
      `${(subtype && `${properCase(subtype)} `) || "Repair Cost (RO)"} (+)`,
    cancellable: true,
    abbrev: "RepCost RO (+)"
  },
  pos_sale: {
    label: "Sale Reversal (+)",
    cancellable: true,
    abbrev: "Sale Rev (+)"
  },
  pos_shop_assist: {
    label: "Shop Assist (+)",
    abbrev: "ShpAsst (+)",
    cancellable: true,
    inventory_only: true
  },
  neg_shop_assist: {
    label: "Shop Assist (-)",
    abbrev: "ShpAsst (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_shop_assist_cost_savings_transferred: {
    label: "Shop Assist Savings Transferred (-)",
    abbrev: "ShpAsst Savings (-)",
    cancellable: true,
    inventory_only: true
  },
  neg_sale: {
    label: subtype =>
      `Sold ${(subtype && `(${properCase(subtype)}) `) || ""}(-)`,
    cancellable: true,
    abbrev: "Sold (-)"
  },
  pos_teardown_cost_transfer: {
    label: "Teardown Cost Transfer (+)",
    cancellable: true,
    abbrev: "Teardown (+)"
  },
  neg_teardown_cost_transfer: {
    label: "Teardown Cost Transfer (-)",
    abbrev: "Teardown (-)",
    cancellable: true
  },
  neg_vendor_rma_credit_issued: {
    label: "Vendor RMA Credit Issued (-)",
    cancellable: true,
    abbrev: "VndRMA Cred Iss (-)"
  },
  pos_warranty_non_reimbursed: {
    label: "Warranty Non-Reimbursed (+)",
    cancellable: true,
    abbrev: "Wrnty NR (+)"
  },
  neg_warranty_non_reimbursed: {
    label: "Warranty Non-Reimbursed (-)",
    cancellable: true,
    abbrev: "Wrnty NR (-)"
  }
};

export const CANCELLABLE_COST_ADJUSTMENTS = Object.keys(
  COST_ADJUSTMENT_OPTIONS
).filter(k => COST_ADJUSTMENT_OPTIONS[k].cancellable);

export const TRACEABILITY = "traceability";
export const TAG_COPIES = "tag_copies";
export const PHOTOS = "photos";
export const EXTERNAL_LINK = "external_link";
export const OTHER = "other";
export const BACK_TO_BIRTH = "back_to_birth";
export const REMOVAL_TAG = "removal_tag";
export const NON_USE_NON_INSTALL = "non_use_non_install";

export const ATTACHMENT_TYPES = {
  [BACK_TO_BIRTH]: {
    label: "Back To Birth Documents"
  },
  [TAG_COPIES]: {
    label: "Tag Copies"
  },
  [TRACEABILITY]: {
    label: "Traceability"
  },
  data_plate_dom_photos: {
    label: "Data Plate / DOM Photos"
  },
  [EXTERNAL_LINK]: {
    label: "External Link"
  },
  commercial_invoice: {
    label: "Commercial Invoice"
  },
  [NON_USE_NON_INSTALL]: {
    label: "Non-Use / Non-Install Statement for Returns"
  },
  final_packaging_photos: {
    label: "Photos - Final Packaging"
  },
  [PHOTOS]: {
    label: "Photos - Receiving Inspection"
  },
  [PHOTOS_RECEIVING_PACKAGING_INSPECTION]: {
    label: "Photos - Receiving Packaging Inspection"
  },
  photos_receiving_inspection: {
    label: "Photos - Shipping Inspection"
  },
  [REMOVAL_TAG]: {
    label: "Removal Tag"
  },
  shipping_checklist: {
    label: "Shipping Checklist"
  },
  other: {
    label: "Other"
  }
};

export const TRACE_TYPES = {
  121: {
    label: "121",
    abbrev: "121"
  },
  125: {
    label: "125",
    abbrev: "125"
  },
  129: {
    label: "129",
    abbrev: "129"
  },
  135: {
    label: "135",
    abbrev: "135"
  },
  145: {
    label: "145",
    abbrev: "145"
  },
  part_91: {
    label: "Part 91",
    abbrev: "Part91"
  },
  foreign_part_91: {
    label: "Foreign Part 91",
    abbrev: "FrgnPrt91"
  },
  certificate_of_conformance: {
    label: "C of C Only",
    abbrev: "C of C"
  },
  foreign_operator: {
    label: "Foreign Operator",
    abbrev: "FrgnOp"
  },
  foreign_repair_station: {
    label: "Foreign Repair Station",
    abbrev: "Frgn145"
  },
  ntr: {
    label: "No Trace",
    abbrev: "NoTrace"
  },
  oem: {
    label: "OEM",
    abbrev: "OEM"
  },
  unknown: {
    label: "Unknown",
    abbrev: "UNK"
  }
};

export const APPLY_LOT_COST = "apply-lot-cost";
export const ASSIGN_EXCHANGE = "assign-exchange";
export const CANCEL_CONSIGNMENT = "cancel-consignment";
export const CREATE_COMMERCIAL_INVOICE = "create-commercial-invoice";
export const CREATE_DUMMY_RECORD = "create-dummy";
export const DOWNLOAD_SCRAP_CERT = "download-scrap-cert";
export const PRINT = "print";
export const PURCHASED_FOR_EXCHANGE_ID = "purchased_for_exchange_id";
export const REMOVE_EMA = "remove-ema";
export const REQUEST_SCRAP_AT_SHOP = "request-scrap-at-shop";
export const RESERVE_INV_FOR_SALE = "reserve-for-sale";
export const RESERVE_INV_FOR_REPAIR = "reserve-for-repair";
export const RETURN_TO_CUSTOMER = "return-to-customer";
export const RETURN_TO_CUSTOMER_V2 = "return-to-customer-v2";
export const RETURN_TO_STOCK = "return-to-stock";
export const RETURN_CORE_TO_CUSTOMER = "return-core-to-customer";
export const UNRESERVE_REPAIR = "unreserve-for-repair";
export const UPDATE_STATUS = "update-status";
export const UPDATE_SRP = "update-srp-status";
export const UPDATE_QC_STATUS = "update-qc-status";
export const SCRAP_REPORT_RECEIVED = "scrap-report-received";
export const SCRAP_INV_LOCALLY = "scrap-locally";
export const SCRAP_AT_SHOP = "scrap-at-shop";
export const SPLIT_INVENTORY = "split-inventory";
export const TRANSFER_INVENTORY = "transfer-inventory";
export const CANCEL_TRANSFER = "cancel-transfer";
export const CANCEL_MOD_TO = "cancel-mod-to";
export const CREATE_VENDOR_RMA = "create-vendor-rma";

export const CONDITION_WARRANTIES = {
  [NEW_ITEM]: "1 year",
  [OVERHAULED]: "1 year",
  [REPAIRED]: "6 months",
  [INSPECTED]: "30 days",
  [AS_REMOVED]: "No warranty, 30 days inspection",
  [BEYOND_REPAIR]: ""
};

export const WARRANTY_OPTIONS = [
  "30 days",
  "60 days",
  "90 days",
  "120 days",
  "6 months",
  "1 year",
  "18 months",
  "24 months",
  "36 months",
  "Warranty by MRO",
  "No warranty",
  "No warranty, 30 days inspection"
];

const ANNIV = "ANNIV";
const ARC = "ARC";
const DARC = "DARC";
const MAPS = "MAPS";
const NAP = "NAP";
const PFONQ = "P-FONQ";
const QUUC = "QUUC";
const SOCS = "SOCS";

export const SRP_CHANGE_REASONS = [
  SOCS,
  DARC,
  ARC,
  QUUC,
  ANNIV,
  MAPS,
  NAP,
  PFONQ,
  OTHER
].reduce(
  (acc, field) => ({ ...acc, [upperCase(field)]: { label: upperCase(field) } }),
  {}
);



// WEBPACK FOOTER //
// ./app/modules/inventories/constants.js